<template>
  <el-dialog
    title="批量转移成品分组"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      ref="form"
      size="small"
      label-width="120px"
      :model="model"
      :rules="rules"
      class="fix-width"
      v-if="visible"
    >
      <el-form-item label="转移数量：">
        {{ model.total }} 条（{{ model.name }}）</el-form-item
      >
      <el-form-item label="转移至分组：" prop="group_name">
        <el-select v-model="model.group_name" style="width: 240px">
          <el-option key="无" label="无" value="无" />
          <el-option
            v-for="item in model.options"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { productList } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      submiting: false,
      rules: {
        group_name: [
          { required: true, message: '请选择分组', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.clone(this.model.filter)
          data.transfer_group_name = this.model.group_name
          if (data.date && data.date.length == 2) {
            data.start_date = data.date[0]
            data.end_date = data.date[1]
          }

          if (this.model.ids.length > 0) {
            let ids = this.model.ids.join('&ids=')
            data = {
              ids: ids,
              transfer_group_name: this.model.group_name,
            }
          }

          this.submiting = true
          let res = await productList(data)
          if (res.code == 0) {
            this.$emit('callback')
            this.visible = false
          }
          this.submiting = false
        }
      })
    },
  },
}
</script>
